<template>
  <a-space>
    <select-day-vue
      :defaultVal="reqPayload.localDate"
      @userDelectDay="selectTime($event, 'localDate')"
    />

    <select-range-day @userPickRangeTime="userPickRangeTime">
    </select-range-day>

    <a-input
      v-model:value="reqPayload.materialBatchNumber"
      @change="handleSearch"
      placeholder="输入物料批号"
      allowClear
    ></a-input>

    <a-select
      v-model:value="reqPayload.materialType"
      placeholder="选择物料类型"
      allowClear
      @change="handleSearch"
    >
      <a-select-option value="电子物料">电子物料</a-select-option>
      <a-select-option value="结构物料">结构物料</a-select-option>
      <a-select-option value="光学物料">光学物料</a-select-option>
    </a-select>

    <a-select
      v-model:value="reqPayload.incomingMaterialProperties"
      placeholder="来料属性"
      allowClear
      @change="handleSearch"
      style="width: 120px"
    >
      <a-select-option value="正常来料">正常来料</a-select-option>
      <a-select-option value="一次换货/返修">一次换货/返修</a-select-option>
      <a-select-option value="二次换货/返修">二次换货/返修</a-select-option>
      <a-select-option value="三次换货/返修">三次换货/返修</a-select-option>
      <a-select-option value="四次换货/返修">四次换货/返修</a-select-option>
      <a-select-option value="五次换货/返修">五次换货/返修</a-select-option>
      <a-select-option value="六次换货/返修">六次换货/返修</a-select-option>
      <a-select-option value="七次换货/返修">七次换货/返修</a-select-option>
      <a-select-option value="八次换货/返修">八次换货/返修</a-select-option>
      <a-select-option value="九次换货/返修">九次换货/返修</a-select-option>
    </a-select>

    <a-select
      v-model:value="reqPayload.inspectionMethod"
      allowClear
      placeholder="抽检/全检"
      @change="handleSearch"
    >
      <a-select-option value="抽检">抽检</a-select-option>
      <a-select-option value="全检">全检</a-select-option>
    </a-select>

    <a-input
      v-model:value="reqPayload.inspector"
      placeholder="检验人"
      allowClear
      @change="handleSearch"
    ></a-input>
  </a-space>
</template>

<script>
import { defineComponent, reactive } from "vue";
import selectRangeDay from "@/components/daypicker/range.vue";
import selectDayVue from "@/views/repairprogress/compoments/selectDay.vue";
import { getlocalDate } from "@/views/productDaily/components/quality/serve/data";

export default defineComponent({
  components: { selectDayVue, selectRangeDay },
  setup(props, context) {
    const reqPayload = reactive({
      startTime: null,
      endTime: null,
      materialType: null,
      materialBatchNumber: null,
      incomingMaterialProperties: null,
      inspectionMethod: null,
      inspector: null,
      localDate: null,
    });

    const handleSearch = () => {
      context.emit("emitSearch", reqPayload);
    };

    const selectTime = (e, type) => {
      reqPayload[type] = e;
      handleSearch();
    };

    const userPickRangeTime = (e) => {
      const [startDate, endDate] = e;
      if (startDate !== "" && endDate !== "") {
        reqPayload.startDate = startDate;
        reqPayload.endDate = endDate;
      } else {
        reqPayload.startDate = null;
        reqPayload.endDate = null;
      }
      handleSearch();
    };

    const init = () => {
      reqPayload.localDate = getlocalDate();
      handleSearch();
    };

    init();

    return {
      reqPayload,
      selectTime,
      userPickRangeTime,
      handleSearch,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
